// Vendor libraries
import cloneDeep from 'lodash.clonedeep';
import equal from 'NewAngular/utils/equal/deep-equal';
import Sortable from 'sortablejs';
import { NgZone } from '@angular/core';
import { DOCUMENT } from '@angular/common';
// Constants
import { CUSTOMIZE_PAGES_FEATURE, LEGACY_QUOTE_PAGE_FEATURE, } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
// Services
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
// Components
import { FeatureNeededComponent } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.component';
// Utils
import { disablePointerEvents, enablePointerEvents } from 'NewAngular/utils/sortable-utils';
import * as i0 from "@angular/core";
import * as i1 from "AccountsApp/ts/services/accounts.service";
import * as i2 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i3 from "../../../../../../search/static/search/ts/features/add-button-autocomplete/add-button-autocomplete.component";
import * as i4 from "@angular/common";
import * as i5 from "../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i6 from "../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-footer.component";
import * as i7 from "../../../../../../entitlements/static/entitlements/ts/features/feature-needed/feature-needed.component";
import * as i8 from "../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i9 from "../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
function StocksEditProfileModalComponent_div_25_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20)(1, "div", 21)(2, "div", 22)(3, "div", 23)(4, "div", 24);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 25)(7, "div", 26);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(8, "svg", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(9, "div", 27);
    i0.ɵɵlistener("click", function StocksEditProfileModalComponent_div_25_Template_div_click_9_listener() { const index_r2 = i0.ɵɵrestoreView(_r1).index; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.removeInfoField(index_r2)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(10, "svg", 7);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const infoField_r4 = ctx.$implicit;
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(infoField_r4.label);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("name", "icon-reorder-up");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-close");
} }
export class StocksEditProfileModalComponent {
    constructor(document, accountsService, featureService, ngZone) {
        this.accountsService = accountsService;
        this.featureService = featureService;
        this.ngZone = ngZone;
        this.defaultInfoFields = [];
        this.infoFields = [];
        this.hiddenInfoFields = [];
        this.defaultOnly = false;
        this.state = {
            errorText: '',
            infoFields: [],
            loading: true,
            modalOpen: false,
            originalInfoFields: [],
        };
        this.profileListContainerId = `profile-list-container-${Math.floor(Math.random() * 99999)}`;
        this.accountsService.useGenericData([LEGACY_QUOTE_PAGE_FEATURE]).subscribe((useGenericData) => {
            this.defaultOnly = useGenericData;
        });
    }
    ngOnInit() { }
    autocompleteHandler(object) {
        const newInfoField = {
            label: object.name,
            name: object.id,
        };
        const existingIndex = this.state.infoFields.findIndex((info) => info.name === newInfoField.name);
        // Prevents description from being added since it should already be a fixed info field
        if (existingIndex !== -1 || newInfoField.label === 'Description') {
            this.setError(`${newInfoField.label} is already in the list.`);
            return false;
        }
        this.state.infoFields.splice(0, 0, newInfoField);
        this.state.errorText = '';
        return true;
    }
    setError(errorText) {
        this.state.errorText = errorText;
    }
    closeModal() {
        this.state.modalOpen = false;
        this.state.errorText = '';
    }
    openModal() {
        if (!this.featureService.userHasFeatures([CUSTOMIZE_PAGES_FEATURE])) {
            this.featureNeededComponent.openModal(CUSTOMIZE_PAGES_FEATURE);
            return;
        }
        // on opening modal lets filter out non data compatible info fields from this list and save them for later
        this.hiddenInfoFields = this.infoFields.filter((field) => !field.visible_for_data_source);
        this.infoFields = this.infoFields.filter((field) => field.visible_for_data_source);
        this.state.infoFields = cloneDeep(this.infoFields);
        this.state.originalInfoFields = cloneDeep(this.infoFields);
        this.initializeSortable();
        this.state.loading = false;
        this.state.modalOpen = true;
    }
    updateOrdering(oldIndex, newIndex) {
        if (oldIndex !== undefined && newIndex !== undefined) {
            this.state.infoFields.splice(newIndex, 0, this.state.infoFields.splice(oldIndex, 1)[0]);
        }
    }
    /**
     * Setup Sortable object for the element `profile-list-container`. Sets the event handlers for the drag
     * actions.
     */
    initializeSortable() {
        const profileContainer = document.getElementById(this.profileListContainerId);
        const className = 'plate-container';
        if (profileContainer) {
            this.ngZone.runOutsideAngular(() => {
                Sortable.create(profileContainer, {
                    handle: '.btn-reorder-up',
                    scroll: false,
                    animation: 150,
                    onUpdate: (evt) => {
                        // The Sortable library is outside of our Angular context so we need to wrap
                        // our handler in a $apply statement so that we are within a digest cycle.
                        this.ngZone.run(() => {
                            this.updateOrdering(evt.oldIndex, evt.newIndex);
                        });
                    },
                    onStart: () => {
                        // Prevent pointer-events on btn classes on click in container for tooltip/sortable bug
                        disablePointerEvents(document, className);
                    },
                    onEnd: () => {
                        enablePointerEvents(document, className);
                    },
                });
            });
        }
    }
    putStockInfoFields() {
        // Because the redesign stock pages have the description section fixed, we didn't include
        // the 'description' info field in `infoFields`, But we do want to keep the description
        // in the `stock_quote_info_fields` user preference, so we'll just add it manually here
        const stockInfoFieldValues = ['description'];
        for (let i = 0; i < this.state.infoFields.length; i += 1) {
            stockInfoFieldValues.push(this.state.infoFields[i].name);
        }
        // add back in hidden info fields when saving preferences
        for (let i = 0; i < this.hiddenInfoFields.length; i += 1) {
            stockInfoFieldValues.push(this.hiddenInfoFields[i].name);
        }
        return this.accountsService.putUserPreferences({ stock_quote_info_fields: stockInfoFieldValues });
    }
    removeInfoField($index) {
        this.state.infoFields.splice($index, 1);
    }
    restoreDefaults() {
        this.hiddenInfoFields = this.defaultInfoFields.filter((field) => !field.visible_for_data_source);
        this.state.infoFields = cloneDeep(this.defaultInfoFields).filter((field) => field.visible_for_data_source);
    }
    submit() {
        if (equal(this.state.originalInfoFields, this.state.infoFields)) {
            this.closeModal();
            return;
        }
        this.putStockInfoFields().subscribe({
            next: () => window.location.reload(),
            error: () => this.setError('Problem updating info fields.'),
        });
    }
    trackByName(index, comparable) {
        return comparable.name;
    }
}
StocksEditProfileModalComponent.ɵfac = function StocksEditProfileModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || StocksEditProfileModalComponent)(i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.AccountsService), i0.ɵɵdirectiveInject(i2.FeatureService), i0.ɵɵdirectiveInject(i0.NgZone)); };
StocksEditProfileModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: StocksEditProfileModalComponent, selectors: [["ycn-stocks-edit-profile-modal"]], viewQuery: function StocksEditProfileModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(FeatureNeededComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.featureNeededComponent = _t.first);
    } }, inputs: { defaultInfoFields: "defaultInfoFields", infoFields: "infoFields" }, standalone: false, decls: 29, vars: 14, consts: [[3, "closeModalHandler", "open", "extraModalClasses", "requiresAction"], [1, "modal-header"], [1, "modal-title"], [1, "modal-header-actions"], [1, "modal-header-action"], [1, "btn", "btn-modal-header", 3, "click"], [1, "btn", "btn-modal-header", "btn-close", 3, "click"], ["ycnIcon", "", 3, "name"], [1, "loader", 3, "hidden"], [1, "loader-message"], [1, "loader-spinner"], [1, "modal-body", 3, "hidden"], [1, "modal-section"], [1, "form-row"], [1, "divider-horizontal"], [3, "submitHandler", "searchType", "defaultOnly"], [1, "form-row", "user-select-none"], [1, "plates", "plates-view-list", 3, "id"], ["class", "plate-container", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "cancelHandler", "submitHandler", "errorText", "hidden", "submitButtonText"], [1, "plate-container"], [1, "plate", "plate-purple"], [1, "plate-header"], [1, "plate-title"], [1, "plate-title-name"], [1, "plate-controls"], ["ycnTooltip", "", "tooltipTitle", "Reorder", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-lightgray", "btn-reorder-up", "plate-control"], ["ycnTooltip", "", "tooltipTitle", "Remove", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-lightgray", "plate-control", 3, "click"]], template: function StocksEditProfileModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0);
        i0.ɵɵlistener("closeModalHandler", function StocksEditProfileModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.closeModal(); });
        i0.ɵɵelementStart(1, "div", 1)(2, "div", 2);
        i0.ɵɵtext(3, "Edit Profile");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3)(5, "div", 4)(6, "div", 5);
        i0.ɵɵlistener("click", function StocksEditProfileModalComponent_Template_div_click_6_listener() { return ctx.restoreDefaults(); });
        i0.ɵɵelementStart(7, "span");
        i0.ɵɵtext(8, "Restore Defaults");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(9, "div", 4)(10, "div", 6);
        i0.ɵɵlistener("click", function StocksEditProfileModalComponent_Template_div_click_10_listener() { return ctx.closeModal(); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(11, "svg", 7);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(12, "div", 8)(13, "div", 9);
        i0.ɵɵtext(14, "Loading");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(15, "div", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "div", 11)(17, "div", 12)(18, "div", 13)(19, "p");
        i0.ɵɵtext(20, " Drag and drop to reorder or search profile items.");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(21, "div", 14);
        i0.ɵɵelementStart(22, "ycn-add-button-autocomplete", 15);
        i0.ɵɵlistener("submitHandler", function StocksEditProfileModalComponent_Template_ycn_add_button_autocomplete_submitHandler_22_listener($event) { return ctx.autocompleteHandler($event); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(23, "div", 16)(24, "div", 17);
        i0.ɵɵtemplate(25, StocksEditProfileModalComponent_div_25_Template, 11, 3, "div", 18);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(26, "div", 14);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(27, "ycn-simple-modal-footer", 19);
        i0.ɵɵlistener("cancelHandler", function StocksEditProfileModalComponent_Template_ycn_simple_modal_footer_cancelHandler_27_listener() { return ctx.closeModal(); })("submitHandler", function StocksEditProfileModalComponent_Template_ycn_simple_modal_footer_submitHandler_27_listener() { return ctx.submit(); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(28, "ycn-feature-needed");
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.state.modalOpen)("extraModalClasses", "modal-sm")("requiresAction", true);
        i0.ɵɵadvance(11);
        i0.ɵɵproperty("name", "icon-close");
        i0.ɵɵadvance();
        i0.ɵɵproperty("hidden", !ctx.state.loading);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("hidden", ctx.state.loading);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("searchType", "stock_info_field")("defaultOnly", ctx.defaultOnly);
        i0.ɵɵadvance(2);
        i0.ɵɵpropertyInterpolate("id", ctx.profileListContainerId);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.state.infoFields)("ngForTrackBy", ctx.trackByName);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("errorText", ctx.state.errorText)("hidden", ctx.state.loading)("submitButtonText", "Update");
    } }, dependencies: [i3.AddButtonAutocompleteComponent, i4.NgForOf, i5.ModalBaseComponent, i6.SimpleModalFooterComponent, i7.FeatureNeededComponent, i8.IconDirective, i9.TooltipDirective], encapsulation: 2 });
